// We will disable some feature in this mode so that QA can finish their job quickly
export const REDUX_MODE_NAMESPACE = 'redux-mode';
export const REMOTE_DEBUGGER_OPTIONS_NAMESPACE = 'remote-debugger-options';
export const LIFECYCLE_EVENT_PREFIX = 'remote_debugger_';
